module.exports = __webpack_public_path__ + "img/DCIImg02.a6341410.png";